import { atom } from 'recoil';
import { ITemplateSectionOptionValue } from './';

export const UploadDocumentOptionState = atom<ITemplateSectionOptionValue>({
	key: 'upload-document-option-state-key',
	default: 'existing',
});
